/** @jsxImportSource @emotion/react */
import { Box, Fade, useMediaQuery, useTheme } from "@mui/material";
import { CircleCover } from "../../../../templates/case_study";
import { LocalizedLink } from "../../../LocalizedLink";

const BlobWithPreview = ({
  caseStudy,
  isVisible,
  changeVisibility,
}: {
  caseStudy: { link: string; image: string };
  isVisible: boolean;
  changeVisibility: (prev: boolean) => void;
}) => {
  const theme = useTheme();
  const isOverMd = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      {isOverMd && (
        <Fade in={isVisible} easing={"ease-in-out"}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "250%",
              maxWidth: "350px",
              aspectRatio: "1 / 1",
              borderRadius: "50%",
              // backgroundColor: "rgba(200, 100, 100, 0.5)",
              // backgroundImage: `url(${caseStudy.imageSrc})`,
            }}
            onMouseOut={() => changeVisibility(false)}
          >
            <LocalizedLink
              to={caseStudy.link}
              css={{
                display: "block",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
              }}
            >
              {/* {caseStudy.image} */}

              <CircleCover
                locale={caseStudy.link}
                backgroundImage={caseStudy.image}
              />
            </LocalizedLink>
          </Box>
        </Fade>
      )}
    </>
  );
};

export default BlobWithPreview;
